import { render, staticRenderFns } from "./buy-history.vue?vue&type=template&id=5311e3c9&scoped=true&"
import script from "./buy-history.vue?vue&type=script&lang=js&"
export * from "./buy-history.vue?vue&type=script&lang=js&"
import style0 from "./buy-history.vue?vue&type=style&index=0&id=5311e3c9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5311e3c9",
  null
  
)

export default component.exports